import { twMerge } from 'tailwind-merge';

type Props = {
  color?: BarColor;
  loading?: boolean;
};

type BarColor = 'default' | 'primary';

const BarColors: Record<BarColor, string> = {
  default: 'bg-zinc-300',
  primary: 'bg-primary-500',
};

const BgColors: Record<BarColor, string> = {
  default: 'bg-zinc-200/50',
  primary: 'bg-primary-100',
};

export function LoadingBar({ color, loading }: Props): JSX.Element {
  const bgClasses = twMerge('h-0.5 w-full overflow-hidden', BgColors[color || 'default']);
  const barClasses = twMerge(
    'animate-progress w-full h-full origin-left-right',
    BarColors[color || 'default'],
  );

  const classes = twMerge('w-full', loading ? '' : 'opacity-0');

  return (
    <div className={classes}>
      <div className={bgClasses}>
        <div className={barClasses}></div>
      </div>
    </div>
  );
}
